export default __webpack_public_path__ + "1e882b8bfb5ed4af7969d3feb7b394d5.png";